import React from "react";
import { mailHref, siteConfig } from "../siteConfig";

const Privacy = () => {
  return (
    <div>
      <div
        className="h-[20rem] bg-center bg-no-repeat bg-cover relative flex items-center justify-start text-white"
        style={{
          backgroundImage: 'url("/img/privacy.jpg")',
        }}
      >
        <h1 className="text-5xl font-bold text-white absolute top-1/3 left-1/4 sm:top-1/4 sm:left-1/3 md:top-1/4 md:left-1/4 lg:top-40 lg:left-28">
          Privacy & Policy
        </h1>
      </div>
      <div className="text-center w-[60%] m-auto py-3 font-teko my-10">
        <h5 className="text-blue-600 text-1xl font-[700]">Privacy & Policy</h5>
      </div>
      <div className="w-[90%] m-auto py-3 text-justify font-teko">
        <ul className="list-disc list-inside mb-4 text-gray-600">
          <li>
            This website is operated by Recon Calibration & Test Labs LLP for
            sharing information about our calibration, testing and support
            services.
          </li>
          <li>
            By using this website, you agree to the collection and use of
            information in accordance with this privacy policy.
          </li>
          <li>
            We collect information only for legitimate business purposes such as
            responding to enquiries, providing quotations, arranging service
            support and improving the website experience.
          </li>
          <li>
            We do not sell personal information to third parties.
          </li>
        </ul>
        <h5 className="text-xl font-bold my-2">Information Collection and Use</h5>
        <ul className="list-disc list-inside mb-4 text-gray-600">
          <li>
            When you submit a form on this website, we may collect your name,
            email address, phone number, company details and message content.
          </li>
          <li>
            This information is used to respond to your request, share service
            information, provide quotations and maintain customer communication.
          </li>
          <li>
            We may also collect limited technical data such as browser type,
            device information and page usage statistics for website analysis.
          </li>
        </ul>
        <h5 className="text-xl font-bold my-2">Log Data</h5>
        <p className="mb-4 text-gray-600">
          Like many websites, we may collect standard log information such as IP
          address, browser version, pages visited, visit time and diagnostic
          data. This information helps us monitor performance, improve content
          and maintain website security.
        </p>
        <h5 className="text-xl font-bold my-2">Cookies</h5>
        <p className="mb-4 text-gray-600">
          This website may use cookies or similar technologies to improve user
          experience, understand site usage and support analytics services. You
          can control cookies through your browser settings. Disabling cookies
          may affect certain website functionality.
        </p>
        <h5 className="text-xl font-bold my-2">Third-Party Services</h5>
        <p className="mb-4 text-gray-600">
          We may use third-party tools and platforms such as email delivery,
          analytics and map services to operate the website effectively. These
          providers may process data only as necessary to deliver their
          respective services.
        </p>
        <h5 className="text-xl font-bold my-2">Data Security</h5>
        <p className="mb-4 text-gray-600">
          We take reasonable steps to protect the information you share with us.
          However, no method of transmission over the internet or electronic
          storage is completely secure, and we cannot guarantee absolute
          security.
        </p>
        <h5 className="text-xl font-bold my-2">External Links</h5>
        <p className="mb-4 text-gray-600">
          Our website may contain links to external websites. We are not
          responsible for the privacy practices or content of those third-party
          sites, and we encourage you to review their policies separately.
        </p>
        <h5 className="text-xl font-bold my-2">Children&apos;s Privacy</h5>
        <p className="mb-4 text-gray-600">
          Our website and services are intended for business and general
          professional use. We do not knowingly collect personal information
          from children.
        </p>
      </div>
      <div className="text-center w-[60%] m-auto py-3 font-teko my-10">
        <h5 className="text-blue-600 text-1xl font-[700]">
          Terms & Conditions
        </h5>
      </div>
      <div className="w-[90%] m-auto py-3 text-justify font-teko">
        <p className="mb-4 text-gray-600">
          The content on this website is provided for general information about
          Recon Calibration & Test Labs LLP and our services. While we aim to
          keep the information accurate and updated, we do not warrant that all
          content will always be complete, current or error-free.
        </p>
        <p className="mb-4 text-gray-600">
          All trademarks, logos, text, graphics and website content are the
          property of Recon Calibration & Test Labs LLP or their respective
          owners and may not be copied, reused or distributed without
          permission.
        </p>
        <p className="mb-4 text-gray-600">
          Submission of an enquiry through this website does not create a
          binding contract. Any commercial engagement, quotation, calibration
          scope, turnaround commitment or service schedule will be subject to
          separate written communication and acceptance.
        </p>
        <p className="mb-4 text-gray-600">
          We reserve the right to update, modify or remove website content at
          any time without prior notice. Continued use of the website after any
          changes means you accept the revised terms.
        </p>
        <h5 className="text-xl font-bold my-2">Changes to This Privacy Policy</h5>
        <p className="mb-4 text-gray-600">
          We may revise this privacy policy and terms from time to time. Any
          updates will be published on this page.
        </p>
        <p className="text-gray-600 mb-4">
          This policy is effective as of July 2, 2026.
        </p>
        <h5 className="text-xl font-bold my-2">Contact Us</h5>
        <p className="mb-4 text-gray-600">
          If you have any questions about this privacy policy or these terms,
          please contact us at{" "}
          <a href={mailHref()} className="text-blue-600 hover:underline">
            {siteConfig.email}
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default Privacy;
